import { Associate } from '../associates/associate.model';
import { Customer } from '../associates/customer.model';
import { DiagnosticTroubleCode } from '../fixed-operations/diagnostic-trouble-code.model';
import { Employee } from '../associates/employee.model';
import { TechnicianGroup } from '../associates/technician-group.model';
import { Till } from '../associates/till.model';
import { Appointment } from './appointment.model';
import { ClaimContinuation } from './claim-continuation.model';
import { ClaimSubmissionType } from './claim-submission-type.model';
import { NissanStatus } from './nissan-status.model';
import { ServiceCode } from '../fixed-operations/service-code.model';
import { WorkOrderAdditionalCharge } from './work-order-additional-charge.model';
import { WorkOrderCase } from './work-order-cases.model';
import { WorkorderDeclinedMpviCode } from './workorder-declined-mpvi-code.model';
import { WorkOrderIntegrationData } from './work-order-integration-data.model';
import { WorkOrderRequestSub } from './work-order-request-sub.model';
import { OemRooftopLink } from '../system/oem-rooftop-link.model';
import { Vehicle } from '../vehicle/vehicle.model';
import { UnitOfMeasure } from '../vehicle/unit-of-measure.model';
import { WorkOrderLabour } from './work-order-labour.model';
import { WorkOrderMechanicHoursActual } from '../fixed-operations/work-order-mechanic-hours-actual.model';

export class WorkOrder {
  appointmentBookingEmployeeId: string = null;
  appointmentDateTime: Date = null;
  appointmentId: number = null;
  assignPriority: string = null;
  autoAssign: string = null;
  billToId: string = null;
  body: string = null;
  bodyReportData: string = null;
  callWhenReady: string = null;
  campaignsFound: number = null;
  carrierCode: string = null;
  caseMovedToWorkOrderId: number = null;
  cashAssociateName: string = null;
  categoryId: number = null;
  chassis: string = null;
  claimContinuationId: number = null;
  claimSubmissionTypeId: number = null;
  communicatorExcludedFrom: boolean = null;
  contactPhoneNumber: string = null;
  createdByVipApp: boolean = null;
  creditCardExpirationDate: Date = null;
  currencyId: string = null;
  customerContacted: boolean = null;
  customerDeductableAmount: number = null;
  customerId: string = null;
  customerInvoicePrint: string = null;
  dateIn: Date = null;
  dateOut: Date = null;
  dateTimePromised: Date = null;
  deductibleByDownAmount: number = null;
  deductibleWaiverFlag: string = null;
  deliveryDate: Date = null;
  department: string = null;
  electronicWorkOrderFlag: string = null;
  embedded?: WorkOrderEmbed = null;
  employeeId: string = null;
  engine: string = null;
  estimateAmount: number = null;
  existsInGmServiceWorkbench: boolean = null;
  followUp: string = null;
  fordCudbSent: boolean = null;
  globalDiscount: number = null;
  gmDdsSent: boolean = null;
  gmDiscountPercent: number = null;
  gstWhenCreated: number = null;
  hazardChargeFlag: boolean = null;
  id: number = null;
  includePricingInfoInCustomerMessage: boolean = null;
  inspectionComplete: boolean = null;
  inspectionSourceApp: boolean = null;
  ivhDateUsed: Date = null;
  ivhUsed: boolean = null;
  labourOnlyInternalTotal: number = null;
  labourOnlyTotal: number = null;
  labourOnlyWarrantyTotal: number = null;
  labourRateHour: number = null;
  labourTotal: number = null;
  last6Vin: string = null;
  leasedVehicleOperator: string = null;
  leaseOperatorId: string = null;
  licenseNumber: string = null;
  linkedToPucharseOrder: string = null;
  mainPostFlag: string = null;
  miscInternalTotal: number = null;
  miscTotal: number = null;
  miscWarrantyTotal: number = null;
  nextCaseStartTime: Date = null;
  nissanStatusId: number = null;
  odometerIn: number = null;
  odometerNext: number = null;
  odometerOut: number = null;
  odometerUpdatedByVehicleDiagnostic: boolean = null;
  openFlag: string = null;
  openFromWorkOrderListFlag: string = null;
  openFromWorkOrderListTimestamp: Date = null;
  originalServiceCode: string = null;
  partsInternalTotal: number = null;
  partsTotal: number = null;
  partsWarrantyTotal: number = null;
  paymentRef: string = null;
  payTypeId: string = null;
  phoneReady: string = null;
  postedStatus: string = null;
  postingEmployee: string = null;
  previousWorkOrder: string = null;
  printGlobalDiscount: string = null;
  printInternalFlag: string = null;
  printVehicleWarrantyId: number = null;
  priorClaimNumber: string = null;
  priorityNumber: number = null;
  pstWhenCreated: number = null;
  purchaseOrder: string = null;
  quoteFlag: string = null;
  ready: string = null;
  realDateIn: Date = null;
  recallLookupJson: string = null;
  recallLookupTimestamp: Date = null;
  reference: string = null;
  requestSymptomsPrintedFlag: string = null;
  rooftopId: number = null;
  salesHeaderId: number = null;
  serialNumber: string = null;
  serialNumber6: string = null;
  series: string = null;
  serviceAdvisorName: string = null;
  serviceAdvisorNumber: string = null;
  serviceCampaignLookupJson: string = null;
  serviceCampaignLookupTimestamp: Date = null;
  serviceCode: string = null;
  serviceVisitId: string = null;
  shopSuppliesPercent: number = null;
  shopSuppliesPercentInternal: number = null;
  statusId: string = null;
  statusModified: Date = null;
  subletInternalTotal: number = null;
  subletTotal: number = null;
  subletWarrantyTotal: number = null;
  typeOfStatus: string = null;
  tagNumber: string = null;
  taxAdjustment: number = null;
  technicianAssignedId: string = null;
  technicianGroupAssignedId: number = null;
  technicianGroupName: string = null;
  tempCaseStatus: string = null;
  tempFlag: string = null;
  tempRequestSymptoms: string = null;
  tillId: number = null;
  totalAmount: number = null;
  totalCases: number = null;
  totalCharges: number = null;
  totalEstimatedTime: number = null;
  totalGst: number = null;
  totalPst: number = null;
  towingAmount: number = null;
  toyotaCvshSent: boolean = null;
  typeId: string = null;
  unitOfMeasurementId: string = null;
  updatedFlag: string = null;
  useCustomerFlag: string = null;
  vehicleCategory: string = null;
  vehicleColour: string = null;
  vehicleDateReceived: Date = null;
  vehicleDateSold: Date = null;
  vehicleId: number = null;
  vehicleMake: string = null;
  vehicleStatusId: string = null;
  vehicleTypeId: string = null;
  vehicleWarrantyId: number = null;
  vendorName: string = null;
  walkaroundComplete: boolean = null;
  warrantyAccepted: string = null;
  warrantyAuditDone: string = null;
  warrantyBlockFlag: string = null;
  warrantyBlockLookupDatetime: Date = null;
  warrantyPrinted: string = null;
  warrantyReportFlag: string = null;
  warrantySubmittedFlag: string = null;
  workOrderTypeId: string = null;
  year: string = null;

  constructor(obj?: WorkOrder) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class WorkOrderEmbed {
  additionalCharges?: WorkOrderAdditionalCharge[] = null;
  appointment?: Appointment = null;
  appointmentBookingEmployee?: Employee = null;
  cases?: WorkOrderCase[] = null;
  claimContinuation?: ClaimContinuation = null;
  claimSubmissionType?: ClaimSubmissionType = null;
  customer?: Customer = null;
  customerAssociate?: Associate = null;
  declinedMpviCodes?: WorkorderDeclinedMpviCode[] = null;
  diagnosticTroubleCodes?: DiagnosticTroubleCode[] = null;
  employee?: Employee = null;
  employeeAssociate?: Associate = null;
  labours?: WorkOrderLabour[];
  nissanStatus?: NissanStatus = null;
  oemRooftopLink?: OemRooftopLink = null;
  requestSub?: WorkOrderRequestSub[] = null;
  serviceAdvisorAssociate?: Associate = null;
  serviceCode?: ServiceCode = null;
  technicianGroup?: TechnicianGroup = null;
  till?: Till = null;
  unitOfMeasure?: UnitOfMeasure = null;
  vehicle?: Vehicle = null;
  workOrderIntegrationData?: WorkOrderIntegrationData = null;
  technicianHours?: WorkOrderMechanicHoursActual[] = null;
}
